import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { StorageService } from 'src/app/services/storage.service';
import { Config } from '../models/config.model';
import { ConfigService } from 'src/app/services/config.service';
import { ConfigActions } from '../actions/config.actions';

export class ConfigStateModel {
    is_refreshing: boolean
    config: Config
}

@State<ConfigStateModel>({
    name: 'config',
    defaults: {
        is_refreshing: true,
        config: new Config()
    }
})
@Injectable()
export class ConfigState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private configService: ConfigService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<ConfigStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                      
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {             
        if (this.storageService.is_initialized) {
            const state_model: ConfigStateModel = change.currentValue      
            this.storageService.set('config', JSON.stringify(state_model))    
        }  
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('config');        
        if (json) {
            const state_model: ConfigStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new ConfigActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new ConfigActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const obj = await this.configService.getAppConfig()    
        if (obj != null) {
          this.store.dispatch(new ConfigActions.Set(obj))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: ConfigStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: ConfigStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getConfig(state: ConfigStateModel) {
        return state.config
    }

    @Action(ConfigActions.Refresh)
    async refresh({patchState}: StateContext<ConfigStateModel>, {  }:ConfigActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(ConfigActions.Init)
    init({setState, getState}: StateContext<ConfigStateModel>, { payload }:ConfigActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new ConfigActions.Refresh())
    }
    
    @Action(ConfigActions.Set)
    set({setState}: StateContext<ConfigStateModel>, { payload }:ConfigActions.Set) {             
        setState({   
            is_refreshing: false,         
            config: payload
        })
    }
}
